import AbstractAnimation from "./abstract-animation";

export default class OpenAccordion extends AbstractAnimation
{
    create(): any {
        this.$element.removeAttr('hidden');
        let targetHeight = this.$element.height();
        this.$element.height(0)
        return this
            .timeline
            .to(this.$element, 0.2, { height: targetHeight, ease: 'power3.easeOut' })
            .set(this.$element, { clearProps: 'all' });

    }
}